import { TCalculationCommonState } from './types';

export function setUploadingDataStatus(
  state: TCalculationCommonState,
  data: TCalculationCommonState['uploadingDataStatus'],
) {
  state.uploadingDataStatus = data;
}
